import { Controller } from "@hotwired/stimulus";

// Toggles between a display view and an inline edit form
export default class extends Controller {
  static targets = ["display", "form"];

  edit() {
    this._showForm();
  }

  cancel() {
    this._showDisplay();
  }

  save() {
    this._showDisplay();
  }

  // Private

  _showForm() {
    this.displayTarget.classList.add("hidden");
    this.formTarget.classList.remove("hidden");
    this._focusFirstInput();
  }

  _showDisplay() {
    this.formTarget.classList.add("hidden");
    this.displayTarget.classList.remove("hidden");
  }

  _focusFirstInput() {
    const input = this.formTarget.querySelector(
      "input, textarea, select, [contenteditable]",
    );
    if (input) input.focus();
  }
}
